import React, { useRef, useEffect } from 'react';
import { TextArea } from './styles';

const AutoResizingTextArea = ({ value = '', onChange, device, error, ...props }) => {
  const textAreaRef = useRef(null);

  const adjustHeight = () => {
    const textArea = textAreaRef.current;
    if (textArea) {
      textArea.style.height = 'auto'; // resetea primero
      const maxHeight = window.innerWidth > 768 ? 664 : 304;
      textArea.style.height = `${Math.min(textArea.scrollHeight, maxHeight)}px`;
    }
  };

  useEffect(() => {
    adjustHeight();
  }, [value]);

  const handleInput = e => {
    adjustHeight();
    onChange(e);
  };

  return (
    <TextArea
      error={error}
      ref={textAreaRef}
      isDesktop={device === 'desktop'}
      value={value}
      onInput={handleInput}
      onChange={onChange}
      data-publi='step-description-description-textArea'
      {...props}
    />
  );
};

export default AutoResizingTextArea;
